/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* A Vikimap service module to use for a Vikimap driven application. Supports Accedo One, JSON and Middleware services. (@accedo/vdkweb-vikimap) 4.0.6
* 
*******************************************************************************/
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _vdkwebFetch = _interopRequireDefault(require("@accedo/vdkweb-fetch"));

var _queryString = require("../utils/queryString");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var MiddlewareEntryProvider = /*#__PURE__*/function () {
  function MiddlewareEntryProvider(rootPath, fetchClient) {
    _classCallCheck(this, MiddlewareEntryProvider);

    this.rootPath = rootPath;
    this.fetchClient = fetchClient || _vdkwebFetch["default"];
  }

  _createClass(MiddlewareEntryProvider, [{
    key: "getPath",
    value: function getPath(path, query) {
      var queryString = (0, _queryString.toQueryString)(query);
      return this.fetchClient("".concat(this.rootPath).concat(path).concat(queryString ? "?".concat(queryString) : '')).then(function (response) {
        return response.json();
      });
    }
    /**
     * Retrieves an entry by ID.
     *
     * @param  {string} id          The ID for the entry to fetch
     * @param  {object} [options]   Custom options params to be passed to the Middleware as query params
     * @return {Promise}            A promise resolving with the entry
     */

  }, {
    key: "getEntryById",
    value: function getEntryById(id, options) {
      return this.getPath("/entry/".concat(id), options)["catch"](function (error) {
        throw {
          id: id,
          error: error
        };
      });
    }
    /**
     * Retrieves a list of entries by an array
     * of IDS.
     *
     * @param  {array} ids          An array of IDs for the entries to fetch
     * @param  {object} [options]   Custom options params to be passed to the Middleware as query params
     * @return {Promise}            A promise resolving with the list of entries
     */

  }, {
    key: "getEntriesByIds",
    value: function getEntriesByIds(ids, options) {
      var idsStr = ids.join(',');
      return this.getPath("/entries/".concat(idsStr), options)["catch"](function (error) {
        throw {
          ids: ids,
          error: error
        };
      });
    }
    /**
     * Retrieves an entry by alias.
     *
     * @param  {string} alias      The alias for the entry to fetch
     * @param  {object} [options]  Custom options params to be passed to the Middleware as query params
     * @return {Promise}           A promise resolving with the entry
     */

  }, {
    key: "getEntryByAlias",
    value: function getEntryByAlias(alias, options) {
      return this.getPath("/entry/alias/".concat(alias), options)["catch"](function (error) {
        throw {
          alias: alias,
          error: error
        };
      });
    }
    /**
     * Retrieves a list of entries by an array
     * of aliases.
     *
     * @param  {array} aliases     An array of aliases for the entries to fetch
     * @param  {object} [options]  Custom options params to be passed to the Middleware as query params
     * @return {Promise}           A promise resolving with the list of entries
     */

  }, {
    key: "getEntriesByAliases",
    value: function getEntriesByAliases() {
      var aliases = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var alias = aliases.join(',');

      var query = _objectSpread(_objectSpread({}, options), {}, {
        alias: alias
      });

      return this.getPath('/entries', query)["catch"](function (error) {
        throw {
          aliases: aliases,
          error: error
        };
      });
    }
    /**
     * Returns all entries available.
     *
     * NOTE: Use with caution.
     *
     * @param {object} [options]           Options for pagination and custom values to be passed on as query params
     *                                     to the middleware.
     * @param {number} options.offset      The offset page number for this request
     * @param {number} options.size        The number of items to fetch in one page request
     * @param {number} options.pageLimit   The max amount of pages to fetch when following pagination results.
     * @param {*} options.{*}              Arbitrary options which will be passed to the middleware
     *
     * @return {array}                     List of all entries
     */

  }, {
    key: "getAllEntries",
    value: function getAllEntries(options) {
      return this.getPath('/entries/all', options)["catch"](function (error) {
        throw {
          error: error
        };
      });
    }
  }]);

  return MiddlewareEntryProvider;
}();

var _default = MiddlewareEntryProvider;
/* eslint-enable no-throw-literal */

exports["default"] = _default;